import { Button as ButtonMUI } from '@mui/material';
import { default as CheckBoxOutlineBlankIconMUI } from '@mui/icons-material/CheckBoxOutlineBlank';
import { default as CheckBoxIconMUI } from '@mui/icons-material/CheckBox';
import { styled } from '@mui/system';
import { theme } from 'oems/theme';


export const ButtonCollapse = styled(ButtonMUI)`
  variant: text;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 14px;
  box-shadow: none;
  font-weight: 400;
  text-transform: none;
  text-align: left;
  &:hover {
    color: ${theme.palette.primary.focus};
  }
`;

export const CheckBoxOutlineBlankIcon = styled(CheckBoxOutlineBlankIconMUI)`
  border: 1rem solid #ced4da important!;
  font-weight: 400 important!;
  custom-icon-checkbox-unchecked {
    color: black !important;
    border: 1rem solid #ced4da important!;
    font-weight: 400 important!;
    font-size: 14px;
  }
`;

export const CheckBoxIcon = styled(CheckBoxIconMUI)`
  font-weight: 400;
`;